import { render, staticRenderFns } from "./monthly_collection.vue?vue&type=template&id=2614770a&"
import script from "./monthly_collection.vue?vue&type=script&lang=js&"
export * from "./monthly_collection.vue?vue&type=script&lang=js&"
import style0 from "./monthly_collection.vue?vue&type=style&index=0&id=2614770a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports